export default {
  modalTitle: 'Êtes-vous sûr de vouloir quitter?',
  modalMessage: 'Si vous quittez maintenant, vous ne pourrez pas vous connecter à l\'Espace client.',
  exit: 'Quitter',
  notNow: 'Annuler',
};
